// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"az_QBb","labelLinkItem":"az_RBb","commonCookieBtnStyles":"az_SBb","cookieButtonElement":"az_TBb","cookieStick":"az_UBb"};